import { getFullAvatarURL } from '@utils/getters'
import type { App, Plugin } from 'vue'
import {
  getSanitizedComponentName,
  getSanitizedComponentFieldName,
} from '@utils/specifics'
import { humanize, capitalize, truncate, toLowerCase } from '@utils/formats'

const installFilters: Plugin = {
  install(app: App): void {
    app.config.globalProperties.$filters = {
      fullAvatarURL: getFullAvatarURL,
      sanitizeComponentName: getSanitizedComponentName,
      sanitizeComponentFieldName: getSanitizedComponentFieldName,
      humanize,
      capitalize,
      truncate,
      toLowerCase,
    }
  },
}

export default installFilters
